import * as React from 'react';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';

import { MtsTicket } from '../models/mtsTicket/mtsTicket';
import { StakeType } from '../api/proto/apiContract';

import { CheckBox, NumberInputForStake } from 'common--design-library';

import { translation, currencyFormatter } from 'easit--localization';
import classNames from 'classnames';

export interface ITicketCardinalityListProps {
    ticket: Instance<typeof MtsTicket>;
}

interface CardinalityLabelProps {
    title: string;
    combinationCount: number;
}
const CardinalityLabel = (props: CardinalityLabelProps) => {
    return <>{translation().bet_System} {props.title} ({props.combinationCount} {translation().combination_short})</>
}

@observer
export class TicketBetListContainer extends React.Component<ITicketCardinalityListProps> {
    get store() {
        return this.props.ticket;
    }

    render() {
        return <React.Fragment>
            {
                this.store.bets !== null &&
                <div className="cardinalities">
                    {
                        this.store.bets.length > 0 &&
                        <div className="cardinality-list mt-2 mb-2">
                            <div className="cardinality-list-header">
                                {translation().coupon_HeaderSystemCouponSetting}
                            </div>
                            <div className="cardinality-list-content">
                                {
                                    this.store.bets.map(item => (

                                        <div className="cardinality-list-item d-flex justify-content-between" key={item.id}>
                                            <CheckBox
                                                onChangehandler={() => { this.store.toggleBetSelectionAsync(item); }}
                                                isChecked={item.isChecked}
                                                roleForTest="cardinality-list__item--checkbox"
                                            >
                                                <CardinalityLabel title={item.title} combinationCount={item.combinationCount} />
                                            </CheckBox>
                                            {
                                                item.stake && this.store.stakeType != StakeType.All && item.isChecked &&
                                                <div>
                                                    <NumberInputForStake
                                                        className={classNames("cardinality-stake", __IsMTSTipos__ ? "text-center" : null)}
                                                        value={item.stake.value}
                                                        canUseDecimals={true}
                                                        onChange={(isValid, value) => { if (this.store.isEnabledUI) { item.setStakeOrValidity(isValid, value); } }}
                                                        onBlur={() => { this.store.isEnabledUI && item.stake.isValid && this.store.setBetStakeAsync(item, item.stake.value); }}
                                                        disabled={!this.store.isEnabledUI}
                                                        roleForTest="cardinality-list__item--stake"
                                                    />
                                                    <span className={classNames(__IsMTSTipos__ ? null : "currency-placeholder")}>
                                                        {this.store.currency}
                                                    </span>
                                                </div>
                                            }
                                            {
                                                this.store.stakeType === StakeType.All && item.isChecked && item.stake &&
                                                <span className={classNames(__IsMTSTipos__ ? "fake-input" : null)}>{currencyFormatter.format(item.stake.value)}</span>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </React.Fragment>;
    }
}
